export default "__VITE_ASSET__Jn1Ln1x2__"